import React from 'react';
import { ArrowRight, Users, Target, Building2, GraduationCap, Award } from 'lucide-react';
import Button from '../../components/Button/Button';
import Card from '../../components/Card/Card';
import './Home.css';

const Home: React.FC = () => {

  const services = [
    {
      icon: <GraduationCap size={32} />,
      title: 'Memberships',
      description: 'Continuous networking and educational opportunities with exclusive monthly presentations from industry leaders.',
      link: '/memberships',
    },
    {
      icon: <Users size={32} />,
      title: 'Baseline Executive Mastermind Course (BLXM)',
      description: 'Comprehensive training courses and expert-led modules to elevate your racquet sports career.',
      link: '/blxm-course',
    },
    {
      icon: <Target size={32} />,
      title: 'Private Club Consulting',
      description: 'Transform underperforming clubs into thriving centers of excellence and profitability.',
      link: '/services#club-consulting',
    },
    {
      icon: <Building2 size={32} />,
      title: 'Retreats',
      description: 'Exclusive annual retreats connecting members with industry leaders at premier destinations.',
      link: '/services#retreats',
    },
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-overlay" />
          <img
            className="hero-video"
            src="/hero.jpg"
            alt="Racquet sports facility"
          />
        </div>
        
        <div className="container hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Reshaping the World of
              <span className="hero-title-accent"> Racquet Sports</span>
            </h1>
            
            <p className="hero-subtitle">
              Drawing on more than a century of collective on and off-court experience, the Baseline team delivers a proven pathway to elevate your career and achieve excellence throughout the racquets industry.
            </p>
            
            <div className="hero-actions">
              <Button variant="primary" size="large" href="/contact">
                Partner With Us
                <ArrowRight size={20} style={{ marginLeft: '8px' }} />
              </Button>
              <Button variant="white" size="large" href="/services">
                Explore Services
              </Button>
            </div>

          </div>
        </div>

      </section>

      {/* Services Section */}
      <section className="section services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title text-center">Our Core Services</h2>
            <p className="section-subtitle text-center">
              Comprehensive solutions tailored to every aspect of racquet sports excellence.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.title}>
                <Card variant="bordered" hoverable animateOnHover>
                  <div className="service-card">
                    <div className="service-icon">{service.icon}</div>
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                    <a href={service.link} className="service-link">
                      Learn More
                      <ArrowRight size={16} />
                    </a>
                  </div>
                </Card>
              </div>
            ))}
          </div>

          <div className="services-cta">
            <Button variant="primary" size="large" href="/services">
              View All Services
            </Button>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <Award size={48} className="cta-icon" />
            <h2 className="cta-title">Ready to Transform Your Racquet Sports Business?</h2>
            <p className="cta-subtitle">
              Join the global leaders who trust Baseline to elevate their game
            </p>
            <div className="cta-actions">
              <Button variant="primary" size="large" href="https://calendar.app.google/zeaz1ocNpttMocbv7">
                Schedule Your Free Consultation
              </Button>
              <Button variant="outline" size="large" href="/about">
                Learn About Us
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
